module.exports = __webpack_public_path__ + "static/media/chevron-down.9cb28880.svg";